import { getAllowlist } from '~/api/allowlist';

export const state = () => ({
  allowlist: {},
});

export const getters = {
  getList: state => state.allowlist || {},
};

export const mutations = {
  setList: (state, data) => {
    state.allowlist = data;
  },
};

export const actions = {
  async getAllowlist({ commit }, { type }) {
    try {
      const response = await getAllowlist(this.$axios, type);
      if (response.meta.http_status === 200) commit('setList', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
};
